import { styled } from "../../../../../../../styles";

export const FormAnswerField = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: "20px",
  marginTop: "30px",

  variants: {
    isForms: {
      true: {
        alignItems: "flex-start",
      },
    },
  },
});

export const Title = styled("p", {
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: "600",
  padding: "5px",
  marginBottom: "10px",
});

export const Description = styled("p", {
  color: "$black",
  alignSelf: "flex-start",
  fontSize: "16px",
  lineHeight: "22px",
  fontFamily: "$openSans",
  fontWeight: "500",
  padding: "5px",
  marginBottom: "10px",
});

export const ImageAttachedContainer = styled("div", {
  width: "calc(100% - 20px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  position: "relative",

  backgroundColor: "var(--colors-gray-30)",
  borderRadius: "8px",

  padding: "12px 16px",
  marginTop: "10px",

  variants: {
    clickable: {
      true: {
        cursor: "pointer",
        "&:hover": {
          opacity: 0.85,
        },
      },
    },
  },
});

export const PreviewModalContent = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  maxWidth: "90vw",
});

export const ImageAttachedText = styled("span", {
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "500",
});

export const DeleteButton = styled("button", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: "20px",
  height: "20px",
  backgroundColor: "var(--colors-error-light)",

  borderRadius: "50%",
  border: "none",
  cursor: "pointer",

  position: "absolute",
  right: "-10px",
  top: "-10px",

  "&:hover": {
    opacity: 0.8,
  },
});

export const ErrorContainer = styled("div", {
  width: "calc(100% - 20px)",
  backgroundColor: "#FDEAEA",
  borderRadius: "8px",
  padding: "12px 16px",
  marginTop: "10px",
});

export const ErrorText = styled("span", {
  color: "#C0392B",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "500",
});

export const WarningText = styled("p", {
  width: "calc(100% - 20px)",
  color: "#E67E22",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "500",
  margin: "10px 0 0 0",
  padding: "0 16px",
});
